/* eslint-disable max-len */
import { Box, IconButton, Typography } from "@mui/material";

import { CloseIcon } from "../Icons";
// import { IUpdateLocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";
import React from "react";

type Props = {
    location: any
    onClose: ((isBubble: boolean) => void) | undefined
    updateLocation?: (selectedLocation: any) => void,
    handleOpenLocationModal?: () => void
    isSignup?: boolean
}

const MapBubble = (props: Props) => {
  const { location, onClose, updateLocation, handleOpenLocationModal, isSignup } = props;

  const handleBubbleClick = (e: any) => {
    e.stopPropagation(); onClose && onClose(false);
    updateLocation ? updateLocation(location): handleOpenLocationModal && handleOpenLocationModal();
  };

  return (
    <Box key={location.idLocation}
      onClick={(e)=>!isSignup && handleBubbleClick(e)}
      onMouseEnter={()=> isSignup && onClose && onClose(false)}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        border: "2px solid #ffc000",
        backgroundColor: "var(--honey-gold-15, #F9EED5)",
        marginBottom: 2,
        height: "144px",
        position: "absolute",
        left: "-170px",
        zIndex: "4",
        width: "330px",
      }}
    >
      {!isSignup && <IconButton aria-label="close"
        onClick={(e) => {
          e.stopPropagation(); onClose && onClose(false);
        }}
        sx={{ position: "absolute", right: 0, top: 0 }}
      >
        <CloseIcon height={18} width={18} color="#000000"/>
      </IconButton>}
      <img src={location?.background} alt="hospital-img" style= {{ height: isSignup ? "144px": "", width: "9.625rem", objectFit: "cover" }}/>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0.3rem",
        }}>
        <Typography variant="h4" sx={{ fontWeight: 600, fontFamily: "geograph-regular" }}>
          {location?.locationName }</Typography>
        <Typography variant="body1" sx={{ fontWeight: 400, fontSize: isSignup? "14px": "1rem", fontFamily: "geograph-regular",
          textAlign: "center" }}>
          {location.address || location?.locationAddress}</Typography>
      </Box>

    </Box>
  );
};

export default MapBubble;
